module.exports = __webpack_public_path__ + "img/sad1.2b8a8b6c.png";